import React from 'react';

import { Container, Table } from './styles';

interface Props {

}
const CustomTable: React.FC<Props> = ({ children }) => {
    return <Container>
        <Table>
            {children}
        </Table>
    </Container>;
}

export default CustomTable;